import { combineReducers } from 'redux';
import * as admin from '@benniehealth/core-js/store/admin';

import exports from './exports';
import sso from './sso';
import users from './users';

export default combineReducers({
  exports,
  sso,
  users,
  perks: admin.perks.slice,
});
